import { heroCover, heroStory } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen overflow-hidden pt-36 md:pt-40">
      {/* 背景封面 */}
      <div className="absolute inset-0">
        <img
          src={heroCover}
          alt="吃瓜黑网深扒头条封面背景图"
          title="吃瓜黑网 内幕揭秘 背后真相"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/60 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-transparent to-background-950/40"></div>
      </div>

      {/* 浮动角标 */}
      <div className="pointer-events-none absolute right-6 top-28 hidden rotate-3 rounded-lg border border-primary-500/40 bg-primary-500/10 px-3 py-2 backdrop-blur md:block">
        <span className="font-heading text-xs font-semibold text-primary-300">🔥 今日热瓜持续发酵</span>
      </div>

      <div className="relative z-10 mx-auto grid w-full max-w-[1280px] grid-cols-1 items-end gap-10 px-4 pb-20 md:px-6 lg:grid-cols-[1.5fr_1fr] lg:pb-24">
        {/* 左：头条深扒 */}
        <div>
          <div className="mb-6 flex items-center gap-3">
            <span className="flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-flashlight-fill text-accent-400"></i>
              深扒档案 · 更新中
            </span>
            <span className="hidden items-center gap-1.5 text-xs text-foreground-400 sm:flex">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
              </span>
              实时跟进
            </span>
          </div>

          <p className="font-heading mb-4 text-sm font-semibold tracking-[0.25em] text-secondary-300">{heroStory.kicker}</p>
          <h1 className="font-heading max-w-3xl text-balance text-3xl font-bold leading-tight text-foreground-50 md:text-5xl md:leading-[1.12]">
            吃瓜黑网<span className="text-primary-400">深扒</span>
            <br className="hidden md:block" />
            {heroStory.title.replace("某头部平台「买量」账本背后：", "")}
          </h1>
          <p className="mt-6 max-w-xl text-balance text-sm leading-relaxed text-foreground-300 md:text-base">{heroStory.lede}</p>

          <div className="mt-7 flex flex-wrap gap-2">
            {heroStory.tags.map((t) => (
              <span
                key={t}
                className="rounded-full border border-background-700 bg-background-850/80 px-3 py-1 text-xs text-foreground-200"
              >
                # {t}
              </span>
            ))}
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <a
              href="#live"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-950 transition-transform hover:-translate-y-0.5 hover:bg-primary-400"
            >
              <i className="ri-eye-line text-lg"></i>
              进入深扒时间线
            </a>
            <a
              href="#mystery"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 bg-background-850/60 px-5 py-3 text-sm font-semibold text-foreground-200 backdrop-blur transition-colors hover:border-background-500 hover:text-foreground-50"
            >
              <i className="ri-question-line text-lg text-accent-400"></i>
              一起拼线索
            </a>
          </div>
        </div>

        {/* 右：事件数据卡 */}
        <div className="rounded-2xl border border-background-700/70 bg-background-900/70 p-6 backdrop-blur-md md:p-8">
          <div className="mb-6 flex items-center justify-between">
            <span className="text-sm font-medium text-foreground-200">事件热度追踪</span>
            <span className="rounded-full bg-secondary-500/15 px-2.5 py-1 text-[11px] text-secondary-300">实时</span>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {[
              { label: "阅读", value: heroStory.statViews },
              { label: "讨论", value: heroStory.statComments },
              { label: "线索", value: "32 条" },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-heading text-lg font-bold text-foreground-50 md:text-xl">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-7">
            <div className="mb-2 flex items-center justify-between text-xs">
              <span className="text-foreground-400">深扒进度</span>
              <span className="font-heading font-semibold text-primary-300">{heroStory.coords}</span>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-full bg-background-700">
              <div className="h-full w-[82%] rounded-full bg-gradient-to-r from-secondary-400 via-primary-400 to-primary-500"></div>
            </div>
            <div className="mt-4 flex items-center justify-between border-t border-background-800 pt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-accent-400"></i>
                {heroStory.statUpdated}
              </span>
              <a href="#insider" className="flex items-center gap-1 font-medium text-accent-300 hover:text-accent-200">
                知情人士新线索
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 底部滚动提示 */}
      <div className="pointer-events-none absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="flex flex-col items-center gap-1 text-foreground-500">
          <span className="text-[10px] tracking-widest">向下深扒</span>
          <i className="ri-arrow-down-line animate-bounce text-lg"></i>
        </div>
      </div>
    </section>
  );
}